@if (label()) {
  <label
    class="mb-x-sm text-sm"
    [class.text-neutral-300]="disabled()"
    [class.cursor-not-allowed]="disabled()"
    [class.text-neutral-900]="!disabled()"
    [class.font-medium]="!disabled()"
    [class.label-required]="required()"
    [for]="id()"
    >{{ label() }}
  </label>
}

<!-- Input Container -->
<div class="relative flex items-center">
  @if (startIcon()) {
    <div
      class="icon start-3"
      [class.opacity-30]="disabled()"
      [class.cursor-not-allowed]="disabled()">
      <img [src]="startIcon()" alt="start-icon" />
    </div>
  }

  <textarea
    [id]="id()"
    [readOnly]="readonly()"
    [style.width]="width()"
    [style.height]="height()"
    [formControlName]="inputFormControlName()"
    [required]="required()"
    [attr.minlength]="minlength()"
    [attr.maxlength]="maxlength()"
    [value]="value() ?? null"
    [placeholder]="displayPlaceholder()"
    class="w-full border border-neutral-300 rounded-md shadow-xs text-sm text-neutral-900 p-md"
    [class]="inputClass()"
    [class.has-errors]="
      childControl.touched && childControl.dirty && childControl.errors
    "
    [class.text-destructive-900]="
      childControl.touched && childControl.dirty && childControl.errors
    "
    [class.text-neutral-300]="disabled()"
    [class.ps-5xl]="startIcon()"
    [class.pe-5xl]="endIcon()"
    [rows]="rowsNumber()"
    [style.resize]="resize() ? 'vertical' : 'none'"
    libTrim></textarea>

  @if (endIcon()) {
    <div
      (click)="applyActionOnEndIconClicked()"
      class="icon end-3 cursor-pointer"
      [class.opacity-30]="disabled()"
      [class.cursor-not-allowed]="disabled()">
      <img [src]="endIcon()" alt="end-icon" />
    </div>
  }
</div>
